import { render, staticRenderFns } from "./CreateTerminals.vue?vue&type=template&id=83089380"
import script from "./CreateTerminals.vue?vue&type=script&lang=js"
export * from "./CreateTerminals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports